// Hierarchy of Permissions (highest → lowest):
//   AdminUser            — Admin Internal (MIS). Total control; add/remove anyone.
//   InternalUser         — Can view everything only; no edits.
//   AdminDistributor     — Add/remove regular distributors, managers, users.
//   DesignatedDistributor— Add/remove managers, users.
//   SiteManager          — Add/remove users and promote/demote managers (on sites they manage).
//   SiteUser             — Bare basic permissions.

export const ROLES = {
  ADMIN_USER: "AdminUser",
  INTERNAL_USER: "InternalUser",
  ADMIN_DISTRIBUTOR: "AdminDistributor",
  DISTRIBUTOR: "DesignatedDistributor",
  SITE_MANAGER: "SiteManager",
  USER: "SiteUser",
};

export function canAccessManagement(role) {
  return !!role && role !== ROLES.USER;
}

export function isViewOnly(role) {
  return role === ROLES.INTERNAL_USER;
}

export function canManageUsers(role, isManagerOfSite = false) {
  switch (role) {
    case ROLES.ADMIN_USER:
    case ROLES.ADMIN_DISTRIBUTOR:
    case ROLES.DISTRIBUTOR:
      return true;
    case ROLES.SITE_MANAGER:
      return isManagerOfSite;
    default:
      return false;
  }
}

export function canManageManagers(role, isManagerOfSite = false) {
  return canManageUsers(role, isManagerOfSite);
}

export function canViewDistributors(role) {
  return (
    role === ROLES.ADMIN_USER ||
    role === ROLES.INTERNAL_USER ||
    role === ROLES.ADMIN_DISTRIBUTOR
  );
}

export function canManageDistributors(role) {
  return role === ROLES.ADMIN_USER || role === ROLES.ADMIN_DISTRIBUTOR;
}

export function canViewInternalDetails(role) {
  return role === ROLES.INTERNAL_USER || role === ROLES.ADMIN_USER;
}
